export const CLASS_NAME = 'cst-dashboard-card-land-cover'
